import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { GridFisheyeCanvas } from '../../shared/GridFisheyeCanvas';
import { useTheme } from '../../../context/ThemeContext';

interface LayoutProps {
  children: React.ReactNode;
  pageTitle?: string;
}

const Layout: React.FC<LayoutProps> = ({ children, pageTitle }) => {
  const { theme } = useTheme();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mouseSpotlight, setMouseSpotlight] = useState(() =>
    typeof window !== 'undefined'
      ? { x: window.innerWidth / 2, y: window.innerHeight / 2 }
      : { x: 0, y: 0 }
  );

  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  const handleLayoutMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    setMouseSpotlight({ x: e.clientX, y: e.clientY });
  };

  return (
    <div
      className="app-layout"
      onMouseMove={handleLayoutMouseMove}
      style={
        {
          '--mouse-x': `${mouseSpotlight.x}px`,
          '--mouse-y': `${mouseSpotlight.y}px`,
        } as React.CSSProperties
      }
    >
      {/* Grid fisheye – grid pulled toward cursor (fish-eye lens effect) */}
      <GridFisheyeCanvas mouseX={mouseSpotlight.x} mouseY={mouseSpotlight.y} theme={theme} />
      {/* Grid spotlight – follows cursor (same as control panel) */}
      <div className="cp-page-grid-spotlight" aria-hidden="true" />
      <div
        className={`sidebar-overlay ${sidebarOpen ? 'sidebar-overlay-visible' : ''}`}
        onClick={closeSidebar}
        onKeyDown={(e) => e.key === 'Escape' && closeSidebar()}
        role="button"
        tabIndex={-1}
        aria-hidden={!sidebarOpen}
        aria-label="Close menu"
      />
      <Sidebar
        isOpen={sidebarOpen}
        onClose={closeSidebar}
      />
      <div className="app-main">
        <Header onMenuClick={toggleSidebar} />
        <main className="app-content">
          {pageTitle && (
            <h1 className="page-title">{pageTitle}</h1>
          )}
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
